import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

@Component({
  selector: 'app-async-selector',
  templateUrl: './async-selector.component.html',
  styleUrls: ['./async-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AsyncSelectorComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AsyncSelectorComponent<T, V> implements ControlValueAccessor, OnInit, OnDestroy {

  @Input()
  public label: string;

  @Input()
  public placeholder: string;

  @Input()
  public set options(opts: Observable<T[]>) {
    if (opts === undefined) {
      throw new Error('options is not defined');
    }

    this.isLoading = true;

    this.selectorOptions = opts
      .pipe(
        tap(() => {
          // this.selectControl.reset();
        }),
        finalize(() => {
          this.isLoading = false;
        })
      );
  }

  @Input()
  public value: string;

  @Input()
  public viewValue: string;

  @Input()
  public required = false;

  @Input()
  public multiple = false;

  @Input()
  public disableOptionKey: string;

  public selectControl = new FormControl(this.value);

  public isLoading = true;

  public selectorOptions: Observable<T[]>;

  private _valueChanges: Subscription;


  constructor() {
    this._valueChanges = this.selectControl.valueChanges
      .subscribe(val => {
        this.onChange(val);
        this.onTouched();
      });
  }

  ngOnInit() {

    if (this.required) {
      this.selectControl.setValidators(Validators.required);
    }
  }

  ngOnDestroy(): void {
    if (this._valueChanges) {
      this._valueChanges.unsubscribe();
    }
  }


  writeValue(value: V): void {
    this.selectControl.setValue(value);
    // this.onChange(value);
  }

  onChange: V & any = () => {
  }

  onTouched: any = () => {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

}
